export function truncateBracketedText(
  text: string,
  maxLength: number = 8
): string {
  return text.replace(/\(([^)]+)\)/g, (match: string, p1: string): string => {
    return p1.length > maxLength ? `(${p1.substring(0, maxLength)}…)` : match;
  });
}

export function truncateWords(text: string, maxLength: number = 8): string {
  return text?.replace(/\b\w{9,}\b/g, (match) => {
    return match.length > maxLength
      ? `${match.substring(0, maxLength)}…`
      : match;
  });
}
